import axios from "axios";
import { redirect } from "react-router-dom";

const api = axios.create({
  headers: {
    "Accept": "application/json",
  },
  withCredentials: false,
});
const getAuthToken = () => {
  return localStorage.getItem("token") || ""; 
};

export const request = async (endpoint: string, method: string = "POST", data: any = {},  isFormData: boolean = false ) => {
  try {
    const token=getAuthToken();
   const headers = {
    Authorization: token ? token : "",
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }else{
    headers["Content-Type"]="multipart/form-data"
  }

    const response = await api({
      url: endpoint,
      method,
      data,
      headers
    });

    return  response.data; 
  } catch (error: any) {
    console.error("API Request Error:", error);
    if (error.response) {
      if (error.response.status === 401) {      
        localStorage.removeItem("token");
        redirect("/");
      }
    } else if (error.request) {
      console.error("No Response Received:", error.request);
    } else {
      console.error("Error Setting Up Request:", error.message);
    }
    throw error;
  }
};
